<div class="dialog-title-row">
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="user-actions">
        <button
            mat-raised-button
            type="button"
            (click)="addUser()">
            {{'ADM_ADDU' | translate}}
        </button>
        <button
            mat-raised-button
            type="button"
            [disabled]="!hasSelectedUserWithoutPendingAction()"
            (click)="editUser()">
            {{'EPU_TITLE' | translate}}
        </button>
        <button
            mat-raised-button
            color="warn"
            type="button"
            [disabled]="!hasSelectedUsersWithoutPendingAction()"
            (click)="removeUsers()">
            {{'U_DELETE_USER' | translate}}
        </button>
        <button
            mat-raised-button
            color="warn"
            type="button"
            [disabled]="!hasSelectedUserWithPendingAction()"
            (click)="cancelUser()">
            {{'endpoint.user.cancel-action' | translate}}
        </button>
    </div>
</div>
<mat-dialog-content>
    <div class="table-wrapper">
        <table
            class="table"
            mat-table
            [dataSource]="pagedUsers"
            aria-describedby="Endpoint users table">
            <ng-container matColumnDef="checkbox">
                <th
                    scope="col"
                    mat-header-cell
                    *matHeaderCellDef>

                    <mat-checkbox
                        [checked]="allSelected"
                        [indeterminate]="someSelected"
                        (change)="toggleSelectAll($event.checked)"
                        aria-label="select/deselect all">
                    </mat-checkbox>
                </th>
                <td
                    mat-cell
                    *matCellDef="let user">

                    <mat-checkbox
                        [checked]="isSelected(user)"
                        (change)="toggleUser(user, $event.checked)"
                        [attr.aria-label]="'select ' + user.username">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="username">
                <th
                    scope="col"
                    mat-header-cell
                    *matHeaderCellDef>
                    {{ 'ADM_UNAME' | translate }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let user">
                    {{ user.username }}
                </td>
            </ng-container>
            <ng-container matColumnDef="email">
                <th
                    scope="col"
                    mat-header-cell
                    *matHeaderCellDef>
                    {{ 'ADM_EMAIL' | translate }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let user">
                    {{ user.email || '-' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="role">
                <th
                    scope="col"
                    mat-header-cell
                    *matHeaderCellDef>
                    {{ 'APU_ROLE' | translate }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let user">
                    @switch (user.role) {
                        @case (ProductUserRole.Invalid) {
                            {{ 'INVALID' | translate }}
                        }
                        @case (ProductUserRole.User) {
                            {{ 'APU_USER' | translate }}
                        }
                        @case (ProductUserRole.UserAdmin) {
                            {{ 'APU_USERADMIN' | translate }}
                        }
                        @case (ProductUserRole.Admin) {
                            {{ 'APU_ADMIN' | translate }}
                        }
                        @default {
                            {{ 'unknown' | translate }}
                        }
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th
                    scope="col"
                    mat-header-cell
                    *matHeaderCellDef>
                    {{'U_STATUS' | translate}}
                </th>
                <td
                    mat-cell
                    *matCellDef="let user">
                    @switch (user.action) {
                        @case (ConsoleAction.ADD_FDE_USER) {
                            {{'endpoint.user.pending-add' | translate}}
                        }
                        @case (ConsoleAction.ADD_PBA_USER) {
                            {{'endpoint.user.pending-add' | translate}}
                        }
                        @case (ConsoleAction.EDIT_FDE_USER) {
                            {{'endpoint.user.pending-modify' | translate}}
                        }
                        @case (ConsoleAction.EDIT_PBA_USER) {
                            {{'endpoint.user.pending-modify' | translate}}
                        }
                        @case (ConsoleAction.REMOVE_FDE_USER) {
                            {{'endpoint.user.pending-removal' | translate}}
                        }
                        @case (ConsoleAction.REMOVE_PBA_USER) {
                            {{'endpoint.user.pending-removal' | translate}}
                        }
                        @default {
                            -
                        }
                    }
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns">
            </tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns">
            </tr>
        </table>
        @if ((data.users?.length ?? 0) === 0) {
            <div class="no-users">
                {{ 'endpoints.no-users' | translate }}
            </div>
        }
    </div>
    <mat-paginator
        [length]="data.users.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25, 50]"
        (page)="handlePageEvent($event)"
        showFirstLastButtons>
    </mat-paginator>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        type="button"
        (click)="close()">
        {{'COPY_CLOSE' | translate}}
    </button>
</mat-dialog-actions>